import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import { SupplierSummaryDto } from "../../shared/dtos/supplier/SupplierSummaryDto";

interface SupplierCardProps {
  supplier: SupplierSummaryDto;
  onView?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onEdit?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const SupplierCard: React.FC<SupplierCardProps> = ({
  supplier,
  onView,
  onEdit,
  onDelete,
}): React.JSX.Element => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" noWrap sx={{ fontWeight: "bold" }}>
              {supplier.name}
            </Typography>
            <Chip
              label={supplier.supplierCode}
              size="small"
              variant="outlined"
              sx={{ mt: 0.5, height: 20 }}
            />
          </Box>
          <Stack direction="row" sx={{ flexShrink: 0, ml: 1 }}>
            {onView && (
              <Tooltip title="View Profile">
                <IconButton size="small" color="info" onClick={onView}>
                  <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              Contact
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "500" }}>
              {supplier.primaryPhone}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body2" noWrap sx={{ maxWidth: "70%" }}>
              {supplier.email || "N/A"}
            </Typography>
          </Box>
          {supplier.website && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <LanguageIcon sx={{ fontSize: 16, color: "text.secondary" }} />
              <Typography
                variant="caption"
                color="info"
                noWrap
                sx={{ maxWidth: "80%" }}
              >
                {supplier.website}
              </Typography>
            </Box>
          )}
        </Stack>
      </Box>
    </StyledCard>
  );
};
export default SupplierCard;
